import React, { Component } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import styles from "../dealerDashBoard/DashboardStyles.module.scss";
import dashboardStyles from "../dealerDashBoard/dashboardStyles";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import crStyles from "../../customerReservation/crStyles";
import NavigateNext from "@material-ui/icons/NavigateNext";
import OrderNotificationsClient from "../../../shared/clients/OrderNotificationsClient";
import CapitalizeText from "../../../utils/CapitalizeText";
import UiDateUtils from "../../../utils/UiDateUtils";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class OrderUpdateNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      notifications: [],
      renderApp: false,
      totalCount: 0,
      totalPages: 0,
      currentPage: 0,
      hasNext: false,
      hasPrevious: false,
      iconUp: false,
    };
    this.hasError = false;
    this.herculesCanViewDealerType =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesCanViewDealerType"
      );
  }

  componentDidMount() {
    this.props.hideOrShow(true, true);
    OrderNotificationsClient.getDealerOrderNotifications(this.props.user)
      .then((data) => {
        this.populateState(data, 1);
      })
      .catch(() => {
        this.hasError = true;
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ renderApp: true });
      });
  }

  handlePrevious = () => {
    this.populateState(this.state.data, this.state.currentPage - 1);
  };

  handleNext = () => {
    this.populateState(this.state.data, this.state.currentPage + 1);
  };

  populateState = (notfi, page) => {
    const data = notfi;
    const notifications = data.slice((page - 1) * 10, 10 * page);
    const totalCount = data.length;
    const totalPages = Math.ceil(totalCount / 10);
    const currentPage = page;
    const hasNext = totalPages > currentPage;
    const hasPrevious = currentPage !== 1;
    this.setState({
      data,
      notifications,
      totalCount,
      totalPages,
      currentPage,
      hasNext,
      hasPrevious,
    });
  };

  markNotificationRead = (id) => {
    OrderNotificationsClient.markNotificationStatusRead(this.props.user, id);
  };

  deleteNotification = (id) => {
    OrderNotificationsClient.deleteNotification(this.props.user, id).then(
      () => {
        this.setState((prevState) => ({
          notifications: this.state.notifications.filter(
            (notification) => notification.id !== id
          ),
          totalCount: prevState.totalCount - 1,
        }));
      }
    );
  };

  getIconType = (notification) => {
    // ReportProblemOutlinedIcon - for actions that need to be resolved
    // ErrorOutlineIcon - for any other sort of notification

    return (
      <ReportProblemOutlinedIcon
        data-testid={`problemIcon-${notification.orderId}`}
        className={styles.actionIconOrders}
      />
    );
  };

  getDocumentDescription = (notification) => {
    const documentName = this.props.t(
      "FinanceLeaseNotifications." + notification.documentName
    );

    return `${notification.orderId} - ${this.props.t(
      "FinanceLeaseNotifications.documentQuery"
    )} - ${documentName}`;
  };

  flipIcon() {
    const current = this.state.iconUp;
    this.setState({ iconUp: !current });
  }

  render() {
    const deleteNotificationSubmit =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "deleteNotificationSubmit"
      );

    function getTableHeader(style, divStyle, column) {
      return (
        <TableCell
          id={column + column}
          style={style}
          // onClick={() => this.handleSort(column)}
        >
          <div className={divStyle}>
            {this.props.t("OrdersDashboard." + column)}
          </div>
        </TableCell>
      );
    }

    let orders = [];
    if (this.state.notifications.length > 0) {
      orders = this.state.notifications;
    }
    return (
      this.state.renderApp &&
      (this.hasError ? (
        <div
          style={dashboardStyles.header}
          className={styles.notificationHeader}
        >
          {this.props.t("DealerDashboard.financeOrLeaseHeader")}
          <h2>{this.props.t("InvalidRoute.header")}</h2>
        </div>
      ) : (
        orders.length > 0 && (
          <div className={styles.tablePadding}>
            <ExpansionPanel
              styles={crStyles.expansionPanel}
              defaultExpanded={false}
              style={{ boxShadow: "none" }}
              onChange={() => this.flipIcon()}
            >
              <ExpansionPanelSummary
                style={crStyles.dashboardHeaderBar}
                id="exp"
              >
                <div className={styles.expansionHeaderBar}>
                  <Grid container>
                    <Grid item md={12} style={crStyles.gridItem}>
                      {this.props.t("DealerDashboard.financeOrLeaseHeader")} (
                      <span data-testid="allNotificationCount">
                        {this.state.totalCount}
                      </span>
                      )
                      {this.state.iconUp ? (
                        <ExpandLessIcon id="less" />
                      ) : (
                        <ExpandMoreIcon id="more" />
                      )}
                    </Grid>
                  </Grid>
                </div>
                <br />
              </ExpansionPanelSummary>
              <Table
                data-testid="notificationsTable"
                key="dealerDashBoardTable"
              >
                <TableHead>
                  <TableRow
                    style={dashboardStyles.dashboardHeader}
                    className={styles.tableHeaderLine}
                  >
                    {getTableHeader.call(
                      this,
                      dashboardStyles.typeHeader,
                      styles.alignStart,
                      "paymentType",
                      0
                    )}
                    {getTableHeader.call(
                      this,
                      dashboardStyles.orderIdHeader,
                      styles.alignStart,
                      "documentReason",
                      1
                    )}
                    {getTableHeader.call(
                      this,
                      dashboardStyles.dateHeader,
                      styles.alignStart,
                      "effectiveFromDate",
                      2
                    )}
                    <TableCell style={dashboardStyles.actionHeader}>
                      <div className={styles.alignStart}>
                        {" "}
                        {this.props.t("OrdersDashboard.action")}{" "}
                      </div>
                    </TableCell>
                    <TableCell style={dashboardStyles.emptyHeader} />
                  </TableRow>
                </TableHead>

                <TableBody>
                  {orders.map((notification, index) => (
                    <TableRow
                      className={
                        notification.readNotification
                          ? styles.textContentBodyListRead
                          : styles.textContentBodyListNew
                      }
                      id={"row" + index}
                      key={index}
                    >
                      <TableCell style={dashboardStyles.leftCell}>
                        {this.getIconType(notification)}
                        {CapitalizeText(notification.paymentType)}
                      </TableCell>
                      <TableCell style={dashboardStyles.centerCell}>
                        {this.getDocumentDescription(notification)}
                      </TableCell>
                      <TableCell
                        className={styles.col3}
                        style={dashboardStyles.centerCell}
                      >
                        {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                          notification.effectiveFromDate
                        )}
                      </TableCell>

                      <TableCell
                        style={dashboardStyles.centerCell}
                        id="reservation"
                        className={styles.col4}
                      >
                        <Link
                          id="reservationLink"
                          onClick={() => {
                            !this.props.fromNscDealerSearch &&
                              this.markNotificationRead(notification.id);
                          }}
                          to={`/dealer/${notification.dealerId}/customer-reservations/order-details/${notification.orderId}`}
                          className={styles.tableLink}
                        >
                          {this.props.t("DealerDashboard.gotoPage")}
                          <ChevronRightIcon style={dashboardStyles.viewIcon} />
                        </Link>
                      </TableCell>
                      <HasPermissionTo
                        permissions={
                          this.props.user.permissions.rolePermissions
                        }
                        perform={["deleteNotification"]}
                        render={() => {
                          return (
                            <TableCell
                              data-testid={`deleteNotification${index}`}
                              style={dashboardStyles.rightCell}
                              className={styles.cursorButton}
                              onClick={(e) =>
                                deleteNotificationSubmit
                                  ? e.stopPropagation()
                                  : this.deleteNotification(notification.id)
                              }
                            >
                              <div className={styles.closeButton}>
                                <Clear />
                              </div>
                            </TableCell>
                          );
                        }}
                        noRender={() => {
                          return <TableCell>&nbsp;</TableCell>;
                        }}
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className={styles.pagesDiv}>
                <button
                  disabled={this.state.hasPrevious === false}
                  data-testid="prev"
                  onClick={() => this.handlePrevious()}
                  className={styles.buttonStyle}
                >
                  <NavigateBefore
                    style={
                      this.state.hasPrevious === false
                        ? crStyles.arrowDisabled
                        : crStyles.arrowEnabled
                    }
                  />
                </button>
                <div className={styles.pages}>
                  {this.state.currentPage} / {this.state.totalPages}
                </div>
                <button
                  disabled={this.state.hasNext === false}
                  data-testid="next"
                  onClick={() => this.handleNext()}
                  className={styles.buttonStyle}
                >
                  <NavigateNext
                    style={
                      this.state.hasNext === false
                        ? crStyles.arrowDisabled
                        : crStyles.arrowEnabled
                    }
                  />
                </button>
              </div>
            </ExpansionPanel>
          </div>
        )
      ))
    );
  }
}

export default withTranslation("emp")(OrderUpdateNotifications);
